import { useApi } from './useApi'

const BASE_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000'

// Las imágenes se guardan con una URL relativa al API; en desarrollo el front
// corre en otro puerto, así que se absolutiza al mostrarlas.
export const metadataImageUrl = (url) =>
  !url || /^https?:\/\//.test(url) ? url : `${BASE_URL}${url}`

// Misma sustitución que hace el servidor, para previsualizar mientras se escribe.
export const renderMetadataTemplate = (template, vars = {}) =>
  String(template || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (match, key) =>
    Object.prototype.hasOwnProperty.call(vars, key) ? String(vars[key] ?? '') : match
  )

// Lee el tamaño real de la imagen antes de subirla: el servidor no procesa
// imágenes y necesita las dimensiones para los meta og:image:width/height.
export const readImageSize = (file) =>
  new Promise((resolve) => {
    const url = URL.createObjectURL(file)
    const img = new Image()
    img.onload = () => {
      URL.revokeObjectURL(url)
      resolve({ width: img.naturalWidth, height: img.naturalHeight })
    }
    img.onerror = () => {
      URL.revokeObjectURL(url)
      resolve({ width: null, height: null })
    }
    img.src = url
  })

// Sube una imagen a la biblioteca indicada (la de la congregación o la del
// sitio): sólo cambia el endpoint, el multipart es el mismo.
export const uploadMetadataImage = async (endpoint, file) => {
  const { width, height } = await readImageSize(file)
  const form = new FormData()
  form.append('imagen', file)
  if (width) form.append('width', width)
  if (height) form.append('height', height)
  const token = localStorage.getItem('token')
  const res = await fetch(`${BASE_URL}${endpoint}`, {
    method: 'POST',
    // Sin Content-Type: el navegador arma el boundary del multipart.
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  })
  // Un rechazo del proxy (413 por tamaño, 502, etc.) responde HTML, no JSON:
  // se traduce a un { error } para que la UI muestre un mensaje entendible.
  try {
    return await res.json()
  } catch {
    if (res.status === 413) return { error: 'La imagen es demasiado grande.' }
    return { error: 'No se pudo subir la imagen.' }
  }
}

export const useLinkMetadata = () => {
  const api = useApi()

  const getMetadata = () => api.get('/api/link-metadata')

  const saveEntry = (payload) => api.put('/api/link-metadata', payload)

  const resetEntry = (scope, scopeKey = '') =>
    api.del(`/api/link-metadata/${scope}${scopeKey ? `/${encodeURIComponent(scopeKey)}` : ''}`)

  const getPreview = ({ type, token }) => {
    const qs = new URLSearchParams({ type, ...(token ? { token } : {}) })
    return api.get(`/api/link-metadata/preview?${qs}`)
  }

  const uploadImage = (file) => uploadMetadataImage('/api/link-metadata/images', file)

  const deleteImage = (id) => api.del(`/api/link-metadata/images/${id}`)

  return { getMetadata, saveEntry, resetEntry, getPreview, uploadImage, deleteImage }
}
